import React, { Component } from 'react';
import { Form, Control } from 'react-redux-form';
import Datepicker from '../../ui/datepicker';
import moment from 'moment';
import { debounce } from 'lodash';

import validators from '../../../helpers/validators';
import states from '../../../helpers/states';
import time from '../../../helpers/times';
import validObj from '../../../helpers/validateObj';
import crossFormValidation from '../../../helpers/crossFormValidation';
import apiRequest from '../../../helpers/apiRequest';
import { envCheck } from '../../../helpers/endpoints';
import { MEDIA_UPLOAD } from '../../../helpers/endpoints';

import Textfield from '../../ui/text-field';
import Select from '../../ui/select';
import Checkbox from '../../ui/checkbox';
import Radio from '../../ui/radio';
import FileUpload from '../../ui/file-upload';
import MultiSelect from '../../ui/multi-select';
import Modal from '../../ui/modal';
import PRModal from '../../ui/modal-pr-confirm';
import AutoSuggest from '../../ui/auto-suggest';
import Textarea from '../../ui/textarea';

class EventInformation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            parentSearchActive: false,
            startTime: '',
            endTime: '',
            startDate: '',
            endDate: ''
        };
        this.approvers = [];

        this.fiscalYears();
    }

    fiscalYears = () => {
        //Got the timestamp from userInfo endpoint and it is from the server time not the user's computer.
        const currentYear = moment(this.props.userInfo.timestamp).format(
            'YYYY'
        );
        const nextYear = moment(this.props.userInfo.timestamp)
            .add('1', 'year')
            .format('YYYY');

        // From Jan 1 to June 30 display the current FY ONLY
        // Default set up
        this.fiscalYears = [
            {
                code: currentYear,
                name: currentYear
            }
        ];

        // From July 1 to Dec 31 display the current and next FY
        if (
            moment().isBetween(
                moment(`${currentYear}-07-01`),
                moment(`${currentYear}-12-31`)
            )
        ) {
            this.fiscalYears.push({
                code: nextYear,
                name: nextYear
            });
        }
    };

    componentDidMount() {
        this.props.category();
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.cost && nextProps.cost) {
            if (this.props.cost.value && nextProps.cost.value) {
                if (this.props.cost.value !== nextProps.cost.value) {
                    this.props.fetchEventApprovers(nextProps.cost.value);
                }
            }
        }

        if (this.props.approvers !== nextProps.approvers) {
            if (nextProps.approvers.length === 1) {
                this.props.setApproverVal(nextProps.approvers[0].code);
            }
        }
        if (!this.props.eventSaveSubmit) {
            this.props.updateFormSave(true);
        }
    }

    canBeInPast = e => {
        let startDate = this.props.startDate;
        let endDate = this.props.endDate;
        let eventCost = this.props.cost.value;
        let currentDate = moment();
        if (startDate < currentDate && endDate < currentDate && eventCost > 0) {
            return false;
        } else {
            return true;
        }
    };

    handleChange = () => {
        let startDate = this.props.startDate;
        let endDate = this.props.endDate;
        if (startDate !== '' && endDate !== '' && !!startDate && !!endDate) {
            if (!(startDate instanceof moment)) {
                startDate = moment(startDate);
            }
            if (!(endDate instanceof moment)) {
                endDate = moment(endDate);
            }
            if (startDate.isAfter(endDate)) {
                var temp = startDate;
                startDate = endDate;
                endDate = temp;
            }
            this.props.setEventDates(startDate, endDate);
        }
    };

    handleChangeStartDate = e => {
        this.setState({ startDate: moment(e) });
        if (this.state.startDate >= this.state.endDate) {
            this.setState({ startTime: '' });
            this.setState({ endTime: '' });
            this.setState({ endDate: '' });
            this.props.resetTime('eDate');
        }
    };

    handleChangeEndDate = e => {
        this.setState({ endDate: moment(e) });
        if (this.state.endDate >= this.state.startDate) {
            this.setState({ startTime: '' });
            this.setState({ endTime: '' });
            this.setState({ startDate: '' });
            this.props.resetTime('sDate');
        }
    };

    handleChangeEndTime = e => {
        this.setState({ endTime: e.target.value });
    };

    handleChangeStartTime = e => {
        this.setState({ startTime: e.target.value });
    };

    handleTime = (time, filter, endTime, startTime, endDate, startDate) => {
        let refinedTime = '';
        if (
            moment(this.props.endDate).format('YYYY-MM-DD') ===
            moment(this.props.startDate).format('YYYY-MM-DD')
        ) {
            if (filter === 'start') {
                let testEnd = moment(this.state.endTime, 'HH:mm').format(
                    'HH:mm'
                );
                if (this.state.endTime !== '') {
                    refinedTime = time.filter(
                        item =>
                            moment(item.code, 'HH:mm').format('HH:mm') <=
                            testEnd
                    );
                } else {
                    refinedTime = time;
                }
            } else if (filter === 'end') {
                let testStart = moment(this.state.startTime, 'HH:mm').format(
                    'HH:mm'
                );
                if (this.state.startTime !== '') {
                    refinedTime = time.filter(
                        item =>
                            moment(item.code, 'HH:mm').format('HH:mm') >=
                            testStart
                    );
                } else {
                    refinedTime = time;
                }
            } else {
                refinedTime = time;
            }
        } else {
            refinedTime = time;
        }
        return refinedTime;
    };

    handleParentSearch = debounce(e => {
        const value = e.target.value;
        if (e.target.value.length >= 4) {
            this.setState({ parentSearchActive: true });
            this.props.fetchParentSearch(value);
        } else {
            this.setState({ parentSearchActive: false });
            this.props.setParentSearch([]);
        }
    }, 750);

    selectParentEvent = e => {
        const index = e.target.getAttribute('data-index');
        const item = this.props.parentSearchResults[index];
        this.props.handleSetParentEvent(item, 'qualifiedName');
        this.setState({ parentSearchActive: false });
    };

    handleSubmit = e => {
        this.props.updateFormSave(true);
        const formsValidObj = crossFormValidation(e);
        this.props.setInvalidTabs(formsValidObj);
        if (formsValidObj.formsValid) {
            const formObj = validObj(e);

            switch (this.props.userAction) {
                case 'recall':
                    this.props.recallEventThunk();
                    break;
                case 'save':
                    if (formObj.id) {
                        this.props.updateEvent(formObj);
                        this.props.updateFormSave(true);
                    } else {
                        this.props.createEvent(formObj);
                        this.props.updateFormSave(true);
                    }
                    break;
                case 'submit':
                    let canSubmit = true;
                    if (this.props.onsiteActivations > 0) {
                        if (
                            this.props.onSiteAddDates &&
                            this.props.onSiteAddDates.length === 0
                        ) {
                            canSubmit = false;
                            this.props.setEventErrorMessage(
                                'Please add at least one on-site date.'
                            );
                        }
                    }
                    if (canSubmit) {
                        if (this.canBeInPast()) {
                            if (formObj.cost > 0 && formObj.contract === '0') {
                                if (this.props.prComplete) {
                                    if (
                                        this.props.purchaseRequest
                                            .PurchaseRequestItem.length > 0
                                    ) {
                                        if (formObj.id) {
                                            this.props.updateAndSubmitEvent(
                                                formObj
                                            );
                                        } else {
                                            this.props.createAndSubmitEvent(
                                                formObj
                                            );
                                        }
                                        this.props.updateFormSave(true);
                                    } else if (
                                        this.props.purchaseRequest.totalCost !==
                                            '' &&
                                        this.props.purchaseRequest
                                            .PurchaseRequestItem.length < 1
                                    ) {
                                        this.props.setEventErrorMessage(
                                            'Please add at least 1 Purchase Request Item to the Purchase Request.'
                                        );
                                    } else {
                                        if (formObj.id) {
                                            this.props.updateAndSubmitEvent(
                                                formObj
                                            );
                                        } else {
                                            this.props.createAndSubmitEvent(
                                                formObj
                                            );
                                        }
                                        this.props.updateFormSave(true);
                                    }
                                } else {
                                    this.props.showPRModal();
                                }
                            } else {
                                if (formObj.id) {
                                    this.props.updateAndSubmitEvent(formObj);
                                    this.props.updateFormSave(true);
                                } else {
                                    this.props.createAndSubmitEvent(formObj);
                                    this.props.updateFormSave(true);
                                }
                            }
                        } else {
                            canSubmit = false;
                            this.props.setEventErrorMessage(
                                'Fee based events cannot occur in the past.'
                            );
                        }
                    }
                    break;
                case 'reject':
                    this.props.rejectEvent(formObj);
                    this.props.updateFormSave(true);
                    break;
                case 'approve':
                    if (this.props.approvers.length === 0) {
                        delete formObj.approverId;
                        this.props.updateFormSave(true);
                    }
                    if (this.props.userInfo.Billet.location === 'MCRC') {
                        if (this.props.mcrcUploadedFile) {
                            this.props.updateAndApproveEvent(formObj);
                            this.props.updateFormSave(true);
                        } else {
                            this.props.setEventErrorMessage(
                                'Please upload a signature of approval document.'
                            );
                            this.props.setEventUserAction(null);
                        }
                    } else if (
                        this.props.userInfo.Billet.location === 'Regional' &&
                        this.props.cost.value > 9999
                    ) {
                        if (this.props.regionalUploadedFile) {
                            this.props.updateAndApproveEvent(formObj);
                            this.props.updateFormSave(true);
                        } else {
                            this.props.setEventErrorMessage(
                                'Please upload a signature of approval document.'
                            );
                            this.props.setEventUserAction(null);
                        }
                    } else if (
                        this.props.userInfo.Billet.location === 'District' &&
                        this.props.cost.value > 9999
                    ) {
                        if (this.props.districtUploadedFile) {
                            this.props.updateAndApproveEvent(formObj);
                            this.props.updateFormSave(true);
                        } else {
                            this.props.setEventErrorMessage(
                                'Please upload a signature of approval document.'
                            );
                            this.props.setEventUserAction(null);
                        }
                    } else if (
                        this.props.userInfo.TrustingUser &&
                        this.props.userInfo.TrustingUser.Billet.location ===
                            'MCRC'
                    ) {
                        if (this.props.mcrcUploadedFile) {
                            this.props.updateAndApproveEvent(formObj);
                            this.props.updateFormSave(true);
                        } else {
                            this.props.setEventErrorMessage(
                                'Please upload a signature of approval document.'
                            );
                            this.props.setEventUserAction(null);
                        }
                    } else if (
                        this.props.userInfo.TrustingUser &&
                        this.props.userInfo.TrustingUser.Billet.location ===
                            'Regional' &&
                        this.props.cost.value > 9999
                    ) {
                        if (this.props.regionalUploadedFile) {
                            this.props.updateAndApproveEvent(formObj);
                            this.props.updateFormSave(true);
                        } else {
                            this.props.setEventErrorMessage(
                                'Please upload a signature of approval document.'
                            );
                            this.props.setEventUserAction(null);
                        }
                    } else if (
                        this.props.userInfo.TrustingUser &&
                        this.props.userInfo.TrustingUser.Billet.location ===
                            'District' &&
                        this.props.cost.value > 9999
                    ) {
                        if (this.props.districtUploadedFile) {
                            this.props.updateAndApproveEvent(formObj);
                            this.props.updateFormSave(true);
                        } else {
                            this.props.setEventErrorMessage(
                                'Please upload a signature of approval document.'
                            );
                            this.props.setEventUserAction(null);
                        }
                    } else if (this.props.eventApproveReject) {
                        if (
                            this.props.userInfo.Billet.name === 'MPA' ||
                            this.props.userInfo.Billet.name === 'MAC'
                        ) {
                            if (this.props.recommend) {
                                if (this.props.recommend.value === '0') {
                                    if (this.props.recommendReason) {
                                        this.props.updateAndApproveEvent(
                                            formObj
                                        );
                                        this.props.updateFormSave(true);
                                    } else {
                                        this.props.setEventErrorMessage(
                                            "Please provide a reason you don't recommend this event."
                                        );
                                        this.props.setEventUserAction(null);
                                    }
                                } else {
                                    this.props.updateAndApproveEvent(formObj);
                                    this.props.updateFormSave(true);
                                    this.props.setEventUserAction(null);
                                }
                            } else {
                                this.props.setEventErrorMessage(
                                    'Please provide a recommendation.'
                                );
                                this.props.setEventUserAction(null);
                            }
                        } else {
                            this.props.approveEvent(formObj);
                            this.props.updateFormSave(true);
                            this.props.setEventUserAction(null);
                        }
                    } else {
                        this.props.approveEvent(formObj);
                        this.props.updateFormSave(true);
                        this.props.setEventUserAction(null);
                    }
                    break;
                case 'request':
                    this.props.requestInfoEvent(formObj);
                    this.props.updateFormSave(true);
                    break;
                case 'update':
                    this.props.updateEvent(formObj);
                    this.props.updateFormSave(true);
                    break;
                case 'hideModal':
                    this.props.hidePRModal();
                    break;
                default:
                    console.log(this.props.userAction);
            }
        } else if (this.props.userAction === 'save') {
            const formObj = validObj(e);

            if (formObj.id) {
                this.props.updateEvent(formObj);
                this.props.updateFormSave(true);
            } else {
                this.props.createEvent(formObj);
                this.props.updateFormSave(true);
            }
        }
    };

    handleSubmitFailed = e => {
        if (this.props.userAction === 'save') {
            if (e.name.value && e.sDate.value && e.startTime.value) {
                const mappedValues = {};
                Object.keys(e).forEach(item => {
                    if (e[item].value) {
                        mappedValues[item] = e[item].value;
                    }
                    if (item === 'vendorsInformation') {
                        const vendors = e[item];
                        mappedValues[item] = [];
                        let newArr = [];
                        for (let val in vendors) {
                            if (val !== '$form') {
                                newArr.push(vendors[val]);
                            }
                        }
                        for (let i = 0; i < newArr.length; i++) {
                            let copyObj = newArr[i];
                            let newObj = {};
                            Object.keys(copyObj).forEach(item => {
                                newObj[item] = copyObj[item].value;
                            });
                            mappedValues[item].push(newObj);
                        }
                    }
                });
                const formObj = validObj(mappedValues);

                const validVendors = mappedValues.vendorsInformation;
                if (e.id && e.id.value) {
                    this.props.updateEvent(formObj, validVendors);
                    this.props.updateFormSave(true);
                } else {
                    this.props.createEvent(formObj, validVendors);
                    this.props.updateFormSave(true);
                }
                this.props.updateFormSave(true);
            }
        } else if (this.props.userAction === 'recall') {
            this.props.recallEventThunk();
        } else if (this.props.userAction === 'reject') {
            const mappedValues = {};
            Object.keys(e).forEach(item => {
                if (e[item].value) {
                    mappedValues[item] = e[item].value;
                }
                if (item === 'vendorsInformation') {
                    const vendors = e[item];
                    mappedValues[item] = [];
                    let newArr = [];
                    for (let val in vendors) {
                        if (val !== '$form') {
                            newArr.push(vendors[val]);
                        }
                    }
                    for (let i = 0; i < newArr.length; i++) {
                        let copyObj = newArr[i];
                        let newObj = {};
                        Object.keys(copyObj).forEach(item => {
                            newObj[item] = copyObj[item].value;
                        });
                        mappedValues[item].push(newObj);
                    }
                }
            });
            const formObj = validObj(mappedValues);
            this.props.rejectEvent(formObj);
            this.props.updateFormSave(true);
        } else if (this.props.userAction === 'request') {
            let eventId = this.props.eventId;
            let comment = this.props.eventForm.comments.value;
            let data = {
                id: eventId,
                comments: comment
            };
            this.props.requestInfoEvent(data);
            this.props.updateFormSave(true);
        } else if (this.props.userAction === 'approve') {
            alert('Please select Assign for Approval and or upload a file.');
            this.props.setEventUserAction(null);
        } else if (this.props.userAction === 'submit') {
            const formsValidObj = crossFormValidation(e);
            this.props.setInvalidTabs(formsValidObj);
        } else {
            this.props.setEventUserAction(null);
        }
        this.props.setEventUserAction(null);
    };

    regionUpdate = e => {
        this.props.updateFundedDistrict(e);
        this.props.updateFundedRS(e);
        this.props.updateFundedRSS(e);
        this.props.setOSSRSSType(e);
    };

    districtUpdate = e => {
        this.props.updateFundedRS(e);
        this.props.updateFundedRSS(e);
        this.props.setOSSRSSType(e);
    };

    handleFileUpload = e => {
        let files = e.target.files;
        let eventId = false;
        if (this.props.eventId) {
            eventId = true;
        }
        for (let i = 0; i < files.length; i++) {
            let file = files[i];
            if (file.size < 10000000) {
                let formData = new FormData();
                formData.append('userfile', file);
                if (eventId) {
                    formData.append('resourceId', this.props.eventId);
                    formData.append('resourceType', 'Event');
                }
                apiRequest(
                    `${MEDIA_UPLOAD}`,
                    this.props.jwtToken,
                    'POST',
                    formData,
                    true
                ).then(response => {
                    if (response.errors) {
                        console.log(response);
                    } else {
                        let filesArray = response.data[0];
                        this.props.handleFiles(filesArray.id);
                        this.props.concatEventUploads(filesArray);

                        if (
                            this.props.userInfo.Billet.location === 'MCRC' &&
                            !this.props.mcrcUploadedFile
                        ) {
                            this.props.setMCRCUploadedFile(true);
                        } else if (
                            this.props.userInfo.Billet.location ===
                                'Regional' &&
                            !this.props.regionalUploadedFile
                        ) {
                            this.props.setRegionalUploadedFile(true);
                        } else if (
                            this.props.userInfo.Billet.location ===
                                'District' &&
                            !this.props.districtUploadedFile
                        ) {
                            this.props.setDistrictUploadedFile(true);
                        }
                    }
                });
            } else {
                this.props.setEventErrorMessage(
                    'Files greater than 10MB in size cannot be uploaded.'
                );
            }
        }
    };

    removeFile(item, index) {
        const id = item.id;
        let payload = {
            id: id,
            type: 'Event',
            eventId: this.props.eventId ? this.props.eventId : 0
        };

        this.props.removeDocumentFiles(index, payload);
    }

    handleRecommendChange = e => {
        const val = e.target.value;
        let bool = true;
        if (val === '0') {
            bool = false;
        }
        this.props.setEventRecommended(bool);
    };

    assignAfterAction = () => {
        this.props.showHideAssignedLocation();
        if (
            !this.props.getShowHideAssignedLocation &&
            this.props.getAssignmentOptions.length === 0
        ) {
            this.props.assignmentOptionsThunk();
        }
    };

    render() {
        const required = validators.required();
        const multiSelectVal = validators.multiSelectVal();
        const reqApprovers = validators.approver();
        const selectValidator = validators.select();
        const empty = validators.empty();
        const noTrim = validators.noTrim();
        const textVal = validators.trimVal();

        let parentResults = null;
        if (this.state.parentSearchActive) {
            parentResults = (
                <AutoSuggest
                    onClick={this.selectParentEvent}
                    listValues={this.props.parentSearchResults}
                    name={'qualifiedName'}
                />
            );
        }

        let hasRecommend = false;
        let disableRecommend = false;
        let disableApprover = false;
        let showApprover = false;

        // if the user has the ability to approve or reject an event
        if (this.props.eventApproveReject) {
            // if approving user is MAC they see the question and can interact with it
            if (this.props.userInfo.Billet.name === 'MAC') {
                hasRecommend = true;
                disableRecommend = false;
            } else if (this.props.showEventRecommend) {
                // if approving user isn't MAC but is an Approver for the event && the MAC has answered the question, they can see the question but not interact with it
                hasRecommend = true;
                disableRecommend = true;
            } else {
                // if the user isn't MAC but is an Approver && the MAC has not answered the question. The question is not shown.
                hasRecommend = false;
                disableRecommend = true;
            }
            // if the user has the ability to save and submit an event
            // they will not see the recommend and its disabled
            showApprover = true;
        } else if (this.props.eventSaveSubmit) {
            hasRecommend = false;
            disableRecommend = true;
            showApprover = true;
        } else if (this.props.showEventRecommend) {
            // if the user is not an approver for the event, but the MAC has answered the question. The question is shown and disabled
            hasRecommend = true;
            disableRecommend = true;
        } else {
            // hide in all other cases
            hasRecommend = false;
            disableRecommend = true;
        }

        if (this.props.approverSet) {
            disableApprover = true;
        }

        let documentRequired = false;
        let documentDisabled = false;

        if (
            !this.props.userInfo.permissions.resources.Event.includes('Create')
        ) {
            documentRequired = false;
            documentDisabled = true;
        }

        if (this.props.status === 'Incomplete' && !this.props.userIsCreator) {
            documentDisabled = true;
        }

        if (this.props.eventSaveSubmit) {
            documentDisabled = false;
            documentRequired = false;
        } else if (this.props.eventApproveReject) {
            // if user is regional and event cost is over 10k, require document upload
            if (
                this.props.userInfo.Billet.location === 'Regional' &&
                this.props.cost.value > 9999
            ) {
                documentDisabled = false;
                documentRequired = true;
            } else if (
                this.props.userInfo.Billet.location === 'District' &&
                this.props.cost.value > 9999
            ) {
                // if user is district and event cost is over 10k, require document upload
                documentDisabled = false;
                documentRequired = true;
            } else {
                documentDisabled = false;
                documentRequired = false;
            }
        }

        let recallBtnStatus = false;

        if (this.props.status === 'Unapproved') {
            if (this.props.tasks.length >= 1) {
                const tasks = this.props.tasks.filter(
                    task =>
                        task.action === 'Review' && task.status === 'Complete'
                );
                recallBtnStatus =
                    tasks.length < 1 && this.props.userIsCreator ? true : false;
            } else {
                recallBtnStatus = true;
            }
        }

        return (
            <Form
                className="form"
                model="event"
                encType="multipart/form-data"
                onSubmit={this.handleSubmit}
                onSubmitFailed={this.handleSubmitFailed}
            >
                <div className="tab__title">Event Information</div>

                <div className="first-col">
                    <div className="form__section-title">General</div>

                    <Textfield
                        model="event.name"
                        isRequired
                        title="Event Name"
                        maxLength="100"
                        validators={{ textVal }}
                        messages={{ textVal: textVal.message }}
                        disabled={!this.props.eventSaveSubmit}
                    />
                    <Datepicker
                        model="event.sDate"
                        className="form__textfield"
                        onChange={this.handleChangeStartDate}
                        startDate={this.state.startDate}
                        endDate={this.props.endDate}
                        selected={this.props.startDate}
                        maxDate={this.state.endDate}
                        id="custom-datepicker"
                        title="Start Date"
                        disabled={!this.props.eventSaveSubmit}
                        validators={{ noTrim }}
                        messages={{
                            noTrim: noTrim.message
                        }}
                        selectsStart={true}
                        isRequired={true}
                    />

                    <Select
                        model="event.startTime"
                        isRequired
                        title="Estimated Start Time"
                        options={this.handleTime(time, 'start')}
                        onChange={this.handleChangeStartTime}
                        validators={{ required }}
                        messages={{ required: required.message }}
                        disabled={!this.props.eventSaveSubmit}
                    />

                    <Datepicker
                        model="event.eDate"
                        className="form__textfield"
                        onChange={this.handleChangeEndDate}
                        startDate={this.props.startDate}
                        endDate={this.state.endDate}
                        selected={this.props.endDate}
                        selectsEnd={true}
                        minDate={this.state.startDate}
                        id="custom-datepicker-two"
                        title="End Date"
                        disabled={!this.props.eventSaveSubmit}
                        validators={{ noTrim }}
                        messages={{
                            noTrim: noTrim.message
                        }}
                        selectsStart={true}
                        isRequired={true}
                    />

                    <Select
                        model="event.endTime"
                        isRequired
                        title="Estimated End Time"
                        options={this.handleTime(time, 'end')}
                        onChange={this.handleChangeEndTime}
                        validators={{ required }}
                        messages={{ required: required.message }}
                        disabled={!this.props.eventSaveSubmit}
                    />

                    <Textfield
                        model="event.city"
                        isRequired
                        title="City"
                        validators={{ textVal }}
                        messages={{ textVal: textVal.message }}
                        disabled={!this.props.eventSaveSubmit}
                    />

                    <Select
                        model="event.state"
                        isRequired
                        title="State"
                        options={states}
                        validators={{ empty }}
                        messages={{ empty: empty.message }}
                        disabled={!this.props.eventSaveSubmit}
                    />

                    <Textfield
                        type="number"
                        model="event.cost"
                        isRequired
                        title="Event Cost"
                        validators={{ required }}
                        messages={{ required: required.message }}
                        onChange={this.props.eventCost}
                        disabled={!this.props.eventSaveSubmit}
                        onKeyPress
                        min="0"
                    />

                    <Checkbox
                        model="event.freeEvent"
                        options={[{ code: '1', name: 'Free Event' }]}
                        onChange={this.props.freeEvent}
                        disabled={!this.props.eventSaveSubmit}
                    />

                    <Select
                        model="event.isFromEac"
                        title="Handheld"
                        isRequired
                        options={[
                            {
                                code: '0',
                                name: 'No'
                            },
                            {
                                code: '1',
                                name: 'Yes'
                            }
                        ]}
                        validators={{ empty }}
                        messages={{ empty: empty.message }}
                        disabled={!this.props.eventSaveSubmit}
                    />

                    <Select
                        model="event.contract"
                        title="ON/OFF CONTRACT"
                        isRequired
                        options={[
                            {
                                code: '0',
                                name: 'Off'
                            },
                            {
                                code: '1',
                                name: 'On'
                            }
                        ]}
                        validators={{ empty }}
                        messages={{ empty: empty.message }}
                        disabled={!this.props.eventSaveSubmit}
                    />

                    <MultiSelect
                        model="event.category"
                        options={this.props.categoryList}
                        categories={this.props.categories}
                        title="Category"
                        isRequired
                        validators={{ multiSelectVal }}
                        messages={{ multiSelectVal: multiSelectVal.message }}
                        disabled={!this.props.eventSaveSubmit}
                        selectedValues={this.props.selectedCategories}
                    />

                    <Textfield
                        model="event.schoolName"
                        title="School Name"
                        disabled={!this.props.eventSaveSubmit}
                    />
                </div>

                <div className="second-col">
                    <div className="form__section-title">Funded By</div>

                    <Select
                        model="event.fundingRegionCode"
                        title="National/Region"
                        onChange={this.regionUpdate}
                        options={this.props.fundedRegionCodeList}
                        disabled={!this.props.eventSaveSubmit}
                    />

                    <Select
                        model="event.fundingDistrictCode"
                        title="District"
                        onChange={this.districtUpdate}
                        options={this.props.fundedDistrictCodeList}
                        disabled={!this.props.eventSaveSubmit}
                    />

                    <Select
                        model="event.fundingRecruitingStationCode"
                        title="RS"
                        onChange={this.props.updateFundedRSS}
                        options={this.props.fundedRecruitingStationCodeList}
                        disabled={!this.props.eventSaveSubmit}
                    />

                    <Select
                        model={'event.fundingRssOrOss'}
                        title="RSS/OSS"
                        onChange={this.props.setOSSRSSType}
                        options={this.props.fundedRecruitingSubStationCodeList}
                        disabled={!this.props.eventSaveSubmit}
                    />

                    <Control.text
                        model="event.fundingRssOrOssType"
                        type="hidden"
                        value={this.props.ossRssType}
                        disabled={!this.props.eventSaveSubmit}
                    />

                    <div className="form__section-title">Assigned Location</div>

                    {this.props.getAssigneeId ? (
                        <div className="form__row">
                            The after action was assigned to{' '}
                            <span className="bold">
                                {this.props.getAssigneeUsername}
                            </span>
                            <br />
                            {this.props.eventSaveSubmit && (
                                <button
                                    type="button"
                                    className="remove-assignee-icon"
                                    onClick={this.props.removeAssignee}
                                    data-assigneeid={this.props.getAssigneeId}
                                >
                                    <svg className="icon icon-close">
                                        <use xlinkHref="#icon-close" />
                                    </svg>
                                    Remove Assignee
                                </button>
                            )}
                        </div>
                    ) : (
                        <div>
                            <Checkbox
                                model="event.assignAfterAction"
                                options={[
                                    {
                                        code: this.props
                                            .getShowHideAssignedLocation,
                                        name: 'Assign After Action'
                                    }
                                ]}
                                onChange={this.assignAfterAction}
                                disabled={!this.props.eventSaveSubmit}
                            />
                            {this.props.getShowHideAssignedLocation && (
                                <div>
                                    <Select
                                        model="event.assignmentOption"
                                        title="Select Assignment Option"
                                        onChange={
                                            this.props.assigneeOptionsThunk
                                        }
                                        isRequired
                                        optGroup
                                        validators={{ selectValidator }}
                                        messages={{
                                            required: selectValidator.message
                                        }}
                                        options={
                                            this.props.getAssignmentOptions
                                        }
                                        disabled={!this.props.eventSaveSubmit}
                                        assignSelect={
                                            this.props.assignAfterActionForm
                                                .$form
                                        }
                                    />

                                    {this.props.getAssigneeOptions.length >
                                        0 && (
                                        <Select
                                            model="event.assignee"
                                            title="Select Assignee"
                                            isRequired
                                            validators={{ required }}
                                            messages={{
                                                required: required.message
                                            }}
                                            options={
                                                this.props.getAssigneeOptions
                                            }
                                            disabled={
                                                !this.props.eventSaveSubmit
                                            }
                                        />
                                    )}
                                    {this.props.getAssigneeLoading && (
                                        <div className="form__row">
                                            Loading ...
                                        </div>
                                    )}
                                    {this.props.getAssigneeOptions.length ===
                                        0 &&
                                        !this.props.getAssigneeLoading && (
                                            <div className="form__row">
                                                There is no assignee available,
                                                please select another assignment
                                                option.
                                            </div>
                                        )}
                                </div>
                            )}
                        </div>
                    )}

                    <Radio
                        isRequired
                        model="event.showParentIdField"
                        title="Linked Events"
                        onChange={this.props.checkMaster}
                        options={[
                            {
                                code: '0',
                                name: 'PARTNERSHIP/MASTER OR STANDALONE EVENT'
                            },
                            {
                                code: '1',
                                name: 'LINK TO PARENT EVENT'
                            }
                        ]}
                        validators={{ empty }}
                        messages={{ empty: empty.message }}
                        disabled={!this.props.eventSaveSubmit}
                    />

                    {this.props.showParentIdField &&
                    this.props.showParentIdField.value === '1' ? (
                        <div>
                            <Textfield
                                title="Parent Event"
                                model="event.parentName"
                                placeholder="Begin Typing Event Name"
                                disabled={!this.props.eventSaveSubmit}
                                onChange={this.handleParentSearch}
                            />

                            {parentResults}
                        </div>
                    ) : null}

                    <Control.text
                        model="event.parentId"
                        type="hidden"
                        disabled
                    />

                    <FileUpload
                        model="event.document"
                        title="Document (Choose file to upload)"
                        isRequired={documentRequired}
                        disabled={documentDisabled}
                        onChange={this.handleFileUpload}
                    />
                    {this.props.uploadedFiles.length > 0 ? (
                        <div className="files files__left files__left--full">
                            <div className="form__title">
                                Attached Documents
                            </div>
                            <ul>
                                {this.props.uploadedFiles.map((item, index) => (
                                    <div
                                        className="files__entry"
                                        key={index}
                                        data-index={index}
                                    >
                                        <div className="files__name">
                                            <span className="files__type">
                                                <svg className="icon icon-image">
                                                    <use
                                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                                        // xlinkHref="#icon-image"
                                                        xlinkHref={`#icon-${
                                                            item.mediaType
                                                        }`}
                                                    />
                                                </svg>
                                            </span>
                                            <a
                                                href={`https://${envCheck}ems.marines.com${
                                                    item.links[0].self
                                                }`}
                                                target="_blank"
                                            >
                                                {item.name}
                                            </a>
                                        </div>

                                        {this.props.eventSaveSubmit && (
                                            <span
                                                className="files__delete"
                                                onClick={() => {
                                                    this.removeFile(
                                                        item,
                                                        index
                                                    );
                                                }}
                                            >
                                                <svg className="icon icon-trash">
                                                    <use
                                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                                        xlinkHref="#icon-trash"
                                                    />
                                                </svg>
                                            </span>
                                        )}
                                    </div>
                                ))}
                            </ul>
                        </div>
                    ) : null}

                    {showApprover &&
                    !this.props.hasAfterActionActions &&
                    this.props.approvers.length > 1 ? (
                        <Select
                            model="event.approverId"
                            title="Assign for Approval"
                            options={this.props.approvers}
                            isRequired
                            validators={{ reqApprovers }}
                            messages={{ reqApprovers: reqApprovers.message }}
                            disabled={disableApprover}
                        />
                    ) : null}

                    <Select
                        model="event.fiscalYear"
                        title="Fiscal Year"
                        options={this.fiscalYears}
                        isRequired
                        validators={{ empty }}
                        messages={{ empty: empty.message }}
                        disabled={!this.props.eventSaveSubmit}
                    />

                    {hasRecommend ? (
                        <Radio
                            isRequired
                            model="event.recommend"
                            title="Would you recommend this event?"
                            options={[
                                {
                                    code: '1',
                                    name: 'Yes'
                                },
                                {
                                    code: '0',
                                    name: 'No'
                                }
                            ]}
                            validators={!disableRecommend ? required : null}
                            messages={{
                                required: !disableRecommend
                                    ? required.message
                                    : null
                            }}
                            onChange={this.handleRecommendChange}
                            disabled={disableRecommend}
                        />
                    ) : null}

                    {!this.props.eventRecommended ? (
                        <Textarea
                            model="event.recommendReason"
                            isRequired
                            title="Why would you not recommend this event?"
                            validators={{ textVal }}
                            messages={{ textVal: textVal.message }}
                            disabled={disableRecommend}
                        />
                    ) : null}
                </div>

                <Control.text
                    model="event.hidden"
                    type="hidden"
                    value="eventId"
                    disabled={!this.props.eventSaveSubmit}
                />

                <div className="form__actions form__actions--global">
                    {recallBtnStatus && (
                        <Control.button
                            className="btn btn--secondary"
                            type="submit"
                            model="event.userActionTaken"
                            onClick={() => {
                                this.props.setEventUserAction('recall');
                            }}
                        >
                            Recall Event
                        </Control.button>
                    )}

                    {this.props.eventSaveSubmit ? (
                        <Control.button
                            className="btn btn--secondary"
                            type="submit"
                            model="event.userActionTaken"
                            value="save"
                            onClick={() => {
                                this.props.setEventUserAction('save');
                            }}
                        >
                            Save
                        </Control.button>
                    ) : null}
                    {this.props.eventSaveSubmit ? (
                        <Control.button
                            className="btn btn--submit"
                            type="submit"
                            model="event.userActionTaken"
                            value="submit"
                            onClick={() => {
                                this.props.setEventUserAction('submit');
                            }}
                        >
                            Submit
                        </Control.button>
                    ) : null}
                    {this.props.eventApproveReject &&
                    this.props.userInfo.permissions.resources.Event.includes(
                        'Reject'
                    ) ? (
                        <Modal
                            title="Reject Event"
                            classes="btn btn--secondary"
                            closeButtonCopy="Cancel"
                            toggleAction={this.props.rejectModalActive}
                            toggleModal={this.props.toggleRejectModal}
                            submitAction={this.props.setEventUserAction}
                            submitValue={'reject'}
                        >
                            <div className="form__section-title">
                                Reject Event
                            </div>
                            <Textfield
                                model="event.rejectComments"
                                title="Rejection Comments"
                                maxLength="250"
                            />
                        </Modal>
                    ) : null}
                    {this.props.eventApproveReject ? (
                        <Modal
                            title="Approve"
                            classes="btn btn--submit"
                            closeButtonCopy="Cancel"
                            toggleAction={this.props.approveModalActive}
                            toggleModal={this.props.toggleApproveModal}
                            submitAction={this.props.setEventUserAction}
                            submitValue={'approve'}
                        >
                            <div className="form__section-title">
                                Approve Event
                            </div>
                        </Modal>
                    ) : null}
                    {this.props.eventApproveReject ? (
                        <Modal
                            title="Returned for Edit"
                            classes="btn btn--secondary"
                            closeButtonCopy="Cancel"
                            toggleAction={this.props.requestModalActive}
                            toggleModal={this.props.toggleRequestModal}
                            submitAction={this.props.setEventUserAction}
                            submitValue={'request'}
                        >
                            <div className="form__section-title">
                                Returned for Edit
                            </div>
                            <Textfield
                                model="event.comments"
                                title="Comments"
                                maxLength="250"
                            />
                        </Modal>
                    ) : null}
                    <PRModal
                        submitAction={this.props.setEventUserAction}
                        setPRComplete={this.props.setPRComplete}
                        toggleAction={this.props.prModalActive}
                        toggleModal={this.props.hidePRModal}
                    >
                        <div className="form__section-title">
                            Submit without a purchase request?
                        </div>
                        <p>
                            Please confirm you would like to submit this event
                            without a purchase request.
                        </p>
                    </PRModal>
                </div>
            </Form>
        );
    }
}

export default EventInformation;



// WEBPACK FOOTER //
// ./src/components/event/event-details/event-information.js